import axios from "axios";
import DefaultGetConfig from "../../../../utils/defaultGetConfig";

function getCarModels(authObj, marca, anio) {
    let carModelsConfig = DefaultGetConfig(authObj);
    carModelsConfig.params = {
        ...carModelsConfig.params,
        marca: marca,
        anio: anio
    }
    let carModelsUrl = process.env.REACT_APP_BACK_SERVER + '/getModelosAutos'
    return axios.get(carModelsUrl, carModelsConfig);
}

export default getCarModels;